const checkAnswer = qParams => {
  let isCorrect = false

  switch (qParams.type) {
    case "fillinblank":
      isCorrect = qParams.answer.includes(qParams.userAnswer.trim().toLowerCase())
      break
    case "multipleresponse":
      // Answer and user answer can be multiple.
      let answersStatus = getMultipleResponseAnswersStatus(qParams)
      isCorrect = !answersStatus.includes(false)
      break
    case "multiplechoice":
    default:
      if (qParams.answer === -1) {
        isCorrect = true
      } else {
        // answer is the index of the choice
        isCorrect = qParams.choiceIndex === qParams.answer
      }
      break
  }

  return isCorrect
}

const getMultipleResponseAnswersStatus = qParams => {
  let answersStatus = []

  for (let i = 0; i < qParams.userAnswer.length; i++) {
    if (qParams.userAnswer[i] === qParams.answer[i]) {
      answersStatus[i] = true
    } else {
      answersStatus[i] = false
    }
  }

  return answersStatus
}

export { checkAnswer, getMultipleResponseAnswersStatus }
